
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Form, Input, Row, Select } from 'antd';
import { useFormik } from "formik";
import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as yup from 'yup';
import { addReportField, updateReportField } from '../../../../actions/companySettings';
import { findLodash, objectToFormData } from '../../../../utils';
import "./../../styles/setting.css";

const { Option } = Select;

const ValidationSchema = yup.object().shape({
  column_name: yup
    .string()
    .required('Please provide category name'),
  column_type: yup.string().required(),
  default_values: yup.mixed().when('column_type', {
    is: 'dropdown',
    then: yup.array().of(yup.object().shape({
      id: yup.string().required(),
      level: yup.string().required(),
    })).required().min(1),
    otherwise: yup.mixed()
  })
});


const AddReportsField = (props) => {
  const { id: currentId } = props;
  const dispatch = useDispatch();

  const [fieldsDeleteData, setFieldsDeleteData] = React.useState([]);
  const reportFieldResponse = useSelector(state => state.companySetting.getReportField || {});

  const formik = useFormik({
    initialValues: {
      column_name: "",
      column_type: "",
      is_required: "",
      view_in_pdf: "",
      default_values: [{ id: 1, level: '' }, { id: 2, level: '' }]
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      const payload = {};
      [
        'column_name',
        'column_type',
        'is_required',
        'is_enable',
        'view_in_pdf',
      ].forEach(item => {
        payload[item] = values[item] || false;
      });

      //const default_values = fieldsData.map(item => item.level);
      const default_values = values?.default_values?.map(item => item.level);


      if (values.column_type === 'dropdown') {
        payload.default_values = [...default_values];
      }

      Object.keys(payload).forEach(key => {
        if (!payload[key] && key !== "is_required" && key !== "is_enable" && key !== "view_in_pdf") {
          delete payload[key];
        }
      });
      currentId ?
        dispatch(updateReportField(objectToFormData({ ...payload, id: currentId.toString() }))) :
        dispatch(addReportField(objectToFormData({ ...payload })));
    }

  })


  React.useEffect(() => {
    formik.resetForm();
    if (reportFieldResponse.success && currentId) {
      const editValues = findLodash(reportFieldResponse.data.response.fields, { id: currentId });
      formik.setValues({
        column_name: editValues.column_name,
        column_type: editValues.column_type,
        is_required: editValues.is_required,
        is_enable: editValues.is_enable,
        view_in_pdf: editValues.view_in_pdf,
        default_values: editValues.default_values?.map((ele, idx) => ({ id: idx + 1, level: ele }))

      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const handleCancelButton = () => {
    formik.resetForm();
    props.handleCancel();
  }

  // const handleFields = (type, key) => {
  //   const fieldsData = formik.values.default_values ? formik.values.default_values : []

  //   if (type === 'add') {
  //     //  setFieldsData([...fieldsData, {id: fieldsData.length + 1, level: ''}]);
  //     formik.setFieldValue('default_values', [...fieldsData, { id: fieldsData.length + 1, level: '' }]);

  //   } else {
  //     setFieldsDeleteData([...fieldsDeleteData, key])
  //     const filterArray = fieldsData.filter(obj => obj.id !== key);
  //     // filterArray.forEach((item, index) => { item['id'] = index + 1 });
  //     // setFieldsData([...filterArray]);
  //     formik.setFieldValue('default_values', [...filterArray]);

  //   }
  // }

  const handleFields = (type, key) => {
    const fieldsData = formik.values.default_values || [];

    if (type === "add") {
      // ✅ Use a guaranteed unique ID like a timestamp
      const newId = Date.now();
      formik.setFieldValue('default_values', [...fieldsData, { id: newId, level: "" }]);
    } else {
      // Your remove logic is already correct as it creates a new array via .filter()
      setFieldsDeleteData([...fieldsDeleteData, key]);
      const filterArray = fieldsData.filter((obj) => obj.id !== key);
      formik.setFieldValue('default_values', filterArray);
    }
  };

  const handleInputs = (evt, key) => {
    // ✅ Create a new array using .map for an immutable update
    const newFieldsData = formik.values.default_values.map(item => {
      if (item.id === key) {
        // This is the item we want to update. Return a new object.
        return { ...item, level: evt.target.value };
      }
      // This is not the item. Return it as is.
      return item;
    });

    formik.setFieldValue('default_values', newFieldsData);
  };

  // const handleInputs = (evt, key) => {
  //   const fieldsData = formik.values.default_values
  //   fieldsData[fieldsData.findIndex((obj => obj.id === key))].level = evt.target.value;
  //   //setFieldsData([...fieldsData]);
  //   formik.setFieldValue('default_values', [...fieldsData]);

  // }

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }

  };

  return (
    <>
      <Form
        layout="vertical"
        //          form={form}
        onFinish={formik.handleSubmit}
        className="modal-form custom-form"
      >
        <Form.Item label="Report Name"
          required={true}
          rules={[{ required: true, message: 'Please enter name' }]}>
          <Input placeholder="Report name" name="column_name"
            onChange={(e) => {
              formik.setFieldValue('column_name', e.target.value.trimStart())
            }}
            value={formik.values.column_name} maxLength={50} />
          {formik.touched.column_name && <div className="errorMsg">{formik.errors.column_name}</div>}

        </Form.Item>
        <Form.Item label="Data Type" rules={[{ required: true, message: 'Please select value' }]}
          required={true}
        >
          <Select
            name="column_type"
            placeholder="Select Column Type"
            value={formik.values.column_type}
            //onChange={(val) => setSelectedDataType(val)}
            onChange={(val) => {
              formik.setFieldValue('column_type', val)
            }}
          >
            <Option value="string">Text Box (Single Line)</Option>
            <Option value="integer">Number (123..)</Option>
            <Option value="dropdown">Dropdown</Option>
            {/* <Option value="checkbox">Check Box</Option>
                  <Option value="multicheckbox">Multi Select</Option> */}
          </Select>
          {formik.touched.column_type && <div className="errorMsg">{formik.errors.column_type}</div>}
        </Form.Item>
        {/*  {selectedDataType === 'dropdown' ?*/}
        {formik.values.column_type === 'dropdown' ?
          <Form.Item label="Default Value">
            <div className='optionsContainer'>
              <Row>
                {formik.values?.default_values?.map((item, index) =>
                  <div key={item.id} className='fieldsDiv mt1'>
                    <span className='inlineItem levelTitle'>Options {index + 1}</span>
                    <Input className='inlineItem'
                      onChange={(e) => handleInputs(e, item.id)} value={item.level}
                      onKeyDown={handleKeyDown}
                    />
                    <MinusCircleOutlined className='minusButton inlineItem mtHalf cursor ml2' onClick={() => handleFields('remove', item.id)} />
                  </div>)}

              </Row>
              <Button type="link" className='addFieldButton mt2' onClick={() => handleFields('add')}>
                <PlusCircleOutlined /> ADD OPTION
              </Button>
            </div>
            {formik.touched.default_values && formik.errors.default_values?.length && <div className="errorMsg">{"Options are required"}</div>}
          </Form.Item> : null}
        <Row>
          <Col span={24}>
            <Form.Item valuePropName="checked">
              <Checkbox name="is_required" checked={formik.values.is_required} onChange={(e) => formik.setFieldValue('is_required', e.target.checked)}>Is Mandatory</Checkbox>
            </Form.Item>
          </Col>
          {/* <Col span={24}>
            <Form.Item valuePropName="checked">
              <Checkbox name="view_in_pdf" checked={formik.values.view_in_pdf} onChange={(e) => formik.setFieldValue('view_in_pdf', e.target.checked)}>Show in all PDF</Checkbox>
            </Form.Item>
          </Col> */}
        </Row>
        {/* <div className='previewDiv'>
            <span>Preview</span>
            <Form.Item label="Invoice Number" name="invoice_number">
                <Input placeholder="Invoice Number" />
            </Form.Item>
          </div> */}
        <Button key="1" htmlType="submit" className="formButton mt1">{currentId ? 'Update' : 'Save'}</Button>
        <Button key="2" className="cancelButton ml1 mt1" onClick={() => handleCancelButton()}>Cancel</Button>
      </Form>
    </>
  );
}

export default AddReportsField;

